<template>
    <div @click="backtop" class="backTop">Top</div>
</template>

<script>
export default {
    methods:{
        backtop(){
            this.$emit('backtop')
        },
    }
}
</script>

<style lang="scss" scoped>
.backTop{
    z-index: 999;
    position: fixed;
    right: 35px;
    bottom: 145px;
    border: 1px solid #b7b7b7;
    border-radius: 50%;
    text-align: center;
    line-height: 30px;
    width: 30px;
    cursor: pointer;
    color: #b7b7b7;

}
.backTop:hover{
    border-color: #000;
    color: #000;
}
</style>